export const ChatMobileStyles = 
{
    grid: {
        backgroundColor: '#F5F5F6',
        paddingTop: '5%',
        paddingBottom: '5%',
        flexShrink: 0
    },
    'grid-icon-back': {
        margin: '0px auto'
    },
    'grid-icon-more': {
        margin: '0px auto'
    },
    'grid-guia': {
        paddingLeft: '5%'
    },
    'box-mensajes':{
        flex: '1',
        overflowY: 'auto' as 'auto',
        minHeight: '0px',
        scrollBehavior: 'smooth' as 'smooth',
    },
    iconbutton: {
        padding: 0
    },
    enviarmensaje: {
        backgroundColor: '#F5F5F6',
        flexShrink: 0,
        bottom: 0,
        width: '100%',
        padding: '10px'
    },
    'box-container':{
        height: 'calc(var(--vh, 1vh) * 100)'
    }
}